// Role-adaptive helpers for the HRD Portal. Reuses the employee's existing `position`
// (no new data / permissions). Drives friendly labels + which quick actions surface first.
import { Briefcase, FileText, GraduationCap, BarChart3, Truck, ListChecks, CalendarDays, Clock } from "lucide-react";

const DRIVER_KEYS = ["driver", "sopir", "pengemudi", "kurir"];
export const isDriver = (pos = "") => DRIVER_KEYS.some((k) => (pos || "").toLowerCase().includes(k));

// Friendly Bahasa Indonesia workspace label per position (existing positions only).
const ROLE_LABELS = {
  cashier: "Kasir",
  waiter: "Pramusaji",
  kitchen: "Dapur",
  supervisor: "Supervisor",
  "branch manager": "Kepala Toko",
  hr: "HRD",
  finance: "Keuangan",
};
export const roleLabel = (pos = "") => {
  const p = (pos || "").toLowerCase();
  if (isDriver(pos)) return "Pengemudi";
  for (const k of Object.keys(ROLE_LABELS)) if (p.includes(k)) return ROLE_LABELS[k];
  return pos || "Karyawan";
};

// Role-adaptive quick actions for the dashboard (all routes already exist).
const ACTIONS = {
  jobdesk: { to: "/karyawan/jobdesk", label: "Job Desk", icon: Briefcase },
  sop: { to: "/karyawan/sop", label: "SOP", icon: FileText },
  training: { to: "/karyawan/training", label: "Training", icon: GraduationCap },
  kpi: { to: "/karyawan/kpi", label: "KPI", icon: BarChart3 },
  tasks: { to: "/karyawan/checklist", label: "Tugas", icon: ListChecks },
  schedule: { to: "/karyawan/jadwal", label: "Jadwal", icon: CalendarDays },
  attendance: { to: "/karyawan/absensi", label: "Absensi", icon: Clock },
  deliveries: { to: "/karyawan/pengiriman", label: "Antar", icon: Truck },
};

export const quickActions = (position = "") => {
  if (isDriver(position)) return [ACTIONS.deliveries, ACTIONS.jobdesk, ACTIONS.sop, ACTIONS.tasks];
  const p = (position || "").toLowerCase();
  if (p.includes("supervisor") || p.includes("manager")) return [ACTIONS.kpi, ACTIONS.jobdesk, ACTIONS.sop, ACTIONS.training];
  // Cashier / Waiter / Kitchen and others — operational first.
  return [ACTIONS.jobdesk, ACTIONS.sop, ACTIONS.training, ACTIONS.kpi];
};
